import {AccountsLinkingCommon} from './accounts-linking-common';

export function AccountsLinkingDefault(): JSX.Element {
    return <AccountsLinkingCommon />;
}
